import type { IGarage, PhotosGroupData } from "@/types/types.d";
import { create } from "zustand";

const initial_store = { garage: "", step: "", orderNumber: "" } as IGarage;

interface CaputureStandState {
  garageData: IGarage;
  garageGroupData: PhotosGroupData[];
  updategarageData: (data: IGarage) => void;
  updateGarageGroupData: (data: PhotosGroupData) => void;
  addGarageGroupData: (data: PhotosGroupData) => void;
  clearGroupData: () => void;
}

const useGarageStore = create<CaputureStandState>((set, get) => ({
  garageData: initial_store,
  garageGroupData: [],
  updategarageData: (data: IGarage) => set({ garageData: data }),
  updateGarageGroupData: (data: PhotosGroupData) => {
    const tmp = get().garageGroupData;

    const new_tmp = tmp.map((group) => {
      if (group.id !== data.id) return group;
      return data;
    });

    set({
      garageGroupData: new_tmp.filter(
        (tmpElement) => tmpElement.photos.length > 0,
      ),
    });
  },
  addGarageGroupData: (data: PhotosGroupData) => {
    const tmp = get().garageGroupData;
    set({ garageGroupData: [...tmp, data] });
  },
  clearGroupData: () => {
    set({ garageData: initial_store });
    set({ garageGroupData: [] });
  },
}));

export default useGarageStore;
